"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMap = exports.mapContext = exports.MapProvider = void 0;
var _globalApiClientReact = require("@ori/global-api-client-react");
var _react = require("react");
var _useDeliveryChannelCoordinatesQuery = require("../api/useDeliveryChannelCoordinatesQuery");
var _useFindPickupPoints = require("../components/FindPickupPoints/useFindPickupPoints");
var _useMapLocation = require("../hooks/useMapLocation");
var _models = require("../models");
var _jsxRuntime = require("react/jsx-runtime");
const mapContext = exports.mapContext = /*#__PURE__*/(0, _react.createContext)({
  isMapEnabled: false,
  mapLocation: {
    currentLocation: undefined,
    currentLocationStatus: _models.CurrentLocationStatus.Waiting,
    isCurrentLocationButtonVisible: false,
    isCurrentLocationEnabled: false,
    isInitialLocationDone: false,
    isPrimaryAddressLoading: true,
    locatePositionInMap: () => {},
    onMapInitialization: () => {},
    primaryAddress: undefined,
    primaryAddressLocation: undefined
  },
  pickupPointsMapProps: {
    activeFilter: 'All',
    instantResultChannelId: undefined,
    instantSearchTerm: '',
    isMapVisible: false,
    selectedMapPickupPoint: undefined,
    selectedDeliveryChannel: undefined,
    onPickupPointItemConfirmation: () => {},
    setSelectedMapPickupPoint: () => {}
  },
  togglePickupPointsDialog: () => {},
  onDeliveryItemActivation: () => {}
});
const MapProvider = ({
  children,
  isMapEnabled,
  selectedDeliveryChannel,
  onDeliveryItemActivation,
  togglePickupPointsDialog: togglePickupPointsDialogProp
}) => {
  const {
    deliveryChannelCoordinates
  } = (0, _useDeliveryChannelCoordinatesQuery.useDeliveryChannelCoordinatesQuery)(selectedDeliveryChannel?.deliveryMethod === _globalApiClientReact.GlobalDeliveryDeliveryChannelDtoDeliveryMethod.Home ? undefined : selectedDeliveryChannel?.deliveryChannelId);
  const {
    pickupPointsMapProps,
    handleLayoutChange,
    togglePickupPointsDialog
  } = (0, _useFindPickupPoints.useFindPickupPoints)({
    isMapEnabled,
    selectedDeliveryChannel: selectedDeliveryChannel ? {
      ...selectedDeliveryChannel,
      coordinates: deliveryChannelCoordinates,
      estimatedDelivery: selectedDeliveryChannel.estimatedDelivery ? new Date(selectedDeliveryChannel.estimatedDelivery) : undefined
    } : undefined,
    onDeliveryItemActivation,
    togglePickupPointsDialog: togglePickupPointsDialogProp
  });
  const mapLocation = (0, _useMapLocation.useMapLocation)({
    disableLatitudeOffset: true,
    instantResultChannelId: pickupPointsMapProps.instantResultChannelId,
    isActive: pickupPointsMapProps.isMapVisible,
    selectedDeliveryChannelCoordinates: deliveryChannelCoordinates
  });
  (0, _react.useEffect)(() => {
    handleLayoutChange(undefined, _models.PickupPointsLayout.Map);
  }, [handleLayoutChange]);
  const value = (0, _react.useMemo)(() => ({
    isMapEnabled,
    mapLocation,
    pickupPointsMapProps,
    selectedDeliveryChannel,
    onDeliveryItemActivation,
    togglePickupPointsDialog
  }), [isMapEnabled, mapLocation, onDeliveryItemActivation, pickupPointsMapProps, selectedDeliveryChannel, togglePickupPointsDialog]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(mapContext.Provider, {
    value: value,
    children: children
  });
};
exports.MapProvider = MapProvider;
const useMap = () => (0, _react.useContext)(mapContext);
exports.useMap = useMap;